import React from 'react';
import List from '../../components/course/List';
import SimpleList from '../../components/course/SimpleList';
import MapWithPin from '../../svg/MapWithPin';
import Filter from '../../svg/Filter';
import Item from '../../components/course/Item';
import Loading from '../../components/Loading';

import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import { withTranslation } from 'react-i18next';
import { getCourses } from '../../../utils/cms';

class App extends React.Component {
	constructor(props){
    super(props);
		this.state = {
			coursePage: JSON.parse(props.data.coursePage),
			courses: null,
			coursesLoaded: false,
			selectedCourse: null,
			displayMode: 'list'
		};

		this.isMedieval = ['medievalCityNo', 'medievalCityEn'].includes(props.data.currentSiteHandle);

		this.selectedCourse = this.selectedCourse.bind(this);
		this.changeDisplayMode = this.changeDisplayMode.bind(this);
		this.getCourses = this.getCourses.bind(this);
  }

	async componentDidMount () {
		this.getCourses();
	}

	async getCourses () {
		try {
			const courses = await getCourses();
			console.log({courses});

			this.setState({courses: courses.data, coursesLoaded: true, selectedCourse: courses.data.length ? courses.data[0] : null});
		} catch (e) {
			console.log({e});
			this.setState({coursesLoaded: false});
		}
	}

	changeDisplayMode (e) {
		this.setState({displayMode: e.target.dataset.type});
	}

	async selectedCourse (course) {
		await this.setState({selectedCourse: null});
		this.setState({selectedCourse: course});
	}

	render () {
		const { courses, coursesLoaded, coursePage, displayMode, selectedCourse } = this.state;
		const { t } = this.props;

		return (
			<section className="main-container wide relative flex flex-col justify-start pt-40 flex-1 flex-shrink-0 min-h-screen pb-20">
				{!!coursePage.mainMedia &&
					<figure className="mask-fadeout-bottom illustration-map absolute top-0 h-screen-80 max-h-180 -right-3/20 xlarge:-right-2/20 xxxlarge:-right-1/20 w-4/5 ml-6 medium:ml-20 hidden medium:flex items-center z-0">
						<img className="mask-fadeout-left absolute left-0 right-0 bottom-0 top-0 my-auto lazyload" data-src={coursePage.mainMedia.url} data-srcset={coursePage.mainMedia.srcset} />
						{displayMode !== 'list' && selectedCourse
							? <img data-src={selectedCourse.graphicsFile} className="route-illustration absolute left-0 right-0 bottom-0 top-0 my-auto lazyload" />
							: null
						}
					</figure>
				}
				<div className="content relative max-w-md mb-20 medium:mb-20">
					<h2 data-aos="fade-up" className="page-title mb-12 medium:mb-20">{coursePage.title}</h2>
					{!this.isMedieval && <div data-aos="fade-up" data-aos-delay="100" className="hidden xlarge:flex flex-wrap items-center mb-12 medium:mb-20">
						<button role="tab" aria-selected={displayMode === 'list' ? 'true' : 'false'} aria-controls={`courses-list`} onClick={this.changeDisplayMode} data-type="list" className={`${displayMode === 'list' ? 'active' : ''} tab-button mr-12`}><span className="mr-2"><Filter /></span>{t('Show as list')}</button>
						<button role="tab" aria-selected={displayMode === 'map' ? 'true' : 'false'} aria-controls={`courses-list-map`} onClick={this.changeDisplayMode} data-type="map" className={`${displayMode === 'map' ? 'active' : ''} tab-button mr-12`}><span className="mr-2"><MapWithPin /></span>{t('Show in map')}</button>
					</div>}
					<div data-aos="fade-up" data-aos-delay="200" className="page-intro max-w-xsm">{parse(DOMPurify.sanitize(coursePage.intro))}</div>
				</div>
				{courses
					? displayMode == 'list'
						? <List courses={courses} isMedieval={this.isMedieval} /> /* include '_modules/_courseTile' with {course: featured} %*/
						: <div id="courses-list-map" className="block large:flex w-full large:items-start mt-0">
							<SimpleList selected={this.selectedCourse} courses={courses} selectedId={selectedCourse ? selectedCourse.id : ''} />
							{selectedCourse ? <div className="flex-1 min-w-0">
								<Item skipMargin={true} course={selectedCourse} isMedieval={this.isMedieval} />
							</div> : null}
						</div>
					: coursesLoaded
						? null
						: <Loading />
				}
			</section>
		);
	}
}
export default withTranslation()(App);
